// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-units tr td a {
  color: var(--texto);
}

.field-hint {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  color: var(--texto2);
}

.unit-details {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

.unit-details  > div {
    width: 100%;
    display: flex;
    gap: 20px;
  }

:is(.unit-details > div)  > div {
      width: 50%;
    }

:is(:is(.unit-details > div) > div)  > div {
        padding: 10px;
        background-color: var(--fundo);
        margin-bottom: 20px;
        border-radius: 12px;
      }

:is(:is(:is(.unit-details > div) > div) > div)  > h5 {
          color: #292d32b4;
        }


.button-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.btn-register-unit {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.div-modal button {
  margin-top: 10px;
}

.btn-unit {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.btn-unit>button {
  font-size: 14px;
  font-weight: 500;
  padding: 6px 8px;
}

.tab {
  display: flex;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: var(--branco);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  padding-top: 10px;
}

.tab button {
  border-radius: 0;
  background: transparent;
  color: var(--texto2);
  font-size: 16px;
  border: none;
}

.tab button:hover {
  scale: 1;
}

.tab button.active {
  border-bottom: 2px solid var(--texto-destaque);
  color: var(--texto-destaque);
}

.tabcontent {
  display: none;
  padding: 6px 12px;
}

.tabcontent  > div button {
    margin-right: 20px;
    padding: 8px 16px;
  }

:is(.tabcontent > div button) .icon {
      width: 18px;
    }

.tabcontent.active {
  display: block;
  min-height: 600px;
}

.btnEditar {
  background: transparent;
  color: var(--azul-escuro);
  font-size: 18px;
  margin-bottom: 20px;
}

.unit-tabs {
  margin-top: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  gap: 8px;
  white-space: nowrap;
  padding: 8px 4px 10px;
  scrollbar-width: thin;
}

.unit-tabs>div,
.unit-tabs button {
  flex: 0 0 auto;
}

.modal .unit-modal-form {
  display: grid;
  flex-direction: unset;
  gap: 12px;
}

.unit-modal-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.unit-modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.unit-modal-field label {
  font-weight: 600;
  color: var(--ui-text);
}

.unit-modal-field input:not([type="checkbox"]),
.unit-modal-field select,
.unit-modal-field textarea {
  width: 100%;
  background: #fff;
  border: 1px solid var(--ui-border);
  border-radius: 10px;
  padding: 10px 12px;
}

.unit-modal-field input[type="checkbox"] {
  width: 18px;
  height: 18px;
  align-self: flex-start;
}

.unit-modal-field textarea {
  min-height: 120px;
  resize: vertical;
}

.unit-modal-field.span-2 {
  grid-column: span 2;
}

.unit-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  grid-column: 1 / -1;
}

@media (max-width: 720px) {
  .unit-modal-grid {
    grid-template-columns: 1fr;
  }

  .unit-modal-field.span-2 {
    grid-column: span 1;
  }
}

/* Css do box */
.box {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
}

.box .existing-services,
.box .added-services {
  width: 50%;
  padding: 10px;
  border-radius: 8px;
  position: relative;
  border: 1px solid #ccc;
  margin-top: 10px;
}

.box .existing-services h2,
.box .added-services h2 {
  text-align: center;
  margin-bottom: 10px;
}

.box li {
  cursor: pointer;
  margin-bottom: 5px;
}

.box li:hover {
  background-color: var(--fundo)
}


.existing-services::before {
  content: '>';
  display: block;
  position: absolute;
  bottom: 5px;
  right: 2px;
  padding: 0px 1px 2px 4px;
  border: 1px solid var(--texto);
  border-radius: 50%;
}

.added-services::after {
  content: '<';
  display: block;
  position: absolute;
  bottom: 5px;
  left: 2px;
  padding: 0px 1px 2px 4px;
  border: 1px solid var(--texto);
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Unidades/unidades.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAsBlB;;AApBE;IACE,WAAW;IACX,aAAa;IACb,SAAS;EAgBX;;AAdE;MACE,UAAU;IAYZ;;AAVE;QACE,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;MAKrB;;AAHE;UACE,gBAAgB;QAClB;;;AAOR;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;AAUnB;;AARE;IACE,kBAAkB;IAClB,iBAAiB;EAKnB;;AAHE;MACE,WAAW;IACb;;AAIJ;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;AACF;;;AAGA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;AACpB","sourcesContent":[".table-units tr td a {\n  color: var(--texto);\n}\n\n.field-hint {\n  display: block;\n  margin-top: 2px;\n  font-size: 11px;\n  color: var(--texto2);\n}\n\n.unit-details {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 20px;\n\n  >div {\n    width: 100%;\n    display: flex;\n    gap: 20px;\n\n    >div {\n      width: 50%;\n\n      >div {\n        padding: 10px;\n        background-color: var(--fundo);\n        margin-bottom: 20px;\n        border-radius: 12px;\n\n        >h5 {\n          color: #292d32b4;\n        }\n      }\n    }\n  }\n}\n\n\n.button-container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn-register-unit {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.div-modal button {\n  margin-top: 10px;\n}\n\n.btn-unit {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n\n.btn-unit>button {\n  font-size: 14px;\n  font-weight: 500;\n  padding: 6px 8px;\n}\n\n.tab {\n  display: flex;\n  overflow: hidden;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  background-color: var(--branco);\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n  padding-top: 10px;\n}\n\n.tab button {\n  border-radius: 0;\n  background: transparent;\n  color: var(--texto2);\n  font-size: 16px;\n  border: none;\n}\n\n.tab button:hover {\n  scale: 1;\n}\n\n.tab button.active {\n  border-bottom: 2px solid var(--texto-destaque);\n  color: var(--texto-destaque);\n}\n\n.tabcontent {\n  display: none;\n  padding: 6px 12px;\n\n  >div button {\n    margin-right: 20px;\n    padding: 8px 16px;\n\n    .icon {\n      width: 18px;\n    }\n  }\n}\n\n.tabcontent.active {\n  display: block;\n  min-height: 600px;\n}\n\n.btnEditar {\n  background: transparent;\n  color: var(--azul-escuro);\n  font-size: 18px;\n  margin-bottom: 20px;\n}\n\n.unit-tabs {\n  margin-top: 8px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  flex-wrap: nowrap;\n  gap: 8px;\n  white-space: nowrap;\n  padding: 8px 4px 10px;\n  scrollbar-width: thin;\n}\n\n.unit-tabs>div,\n.unit-tabs button {\n  flex: 0 0 auto;\n}\n\n.modal .unit-modal-form {\n  display: grid;\n  flex-direction: unset;\n  gap: 12px;\n}\n\n.unit-modal-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.unit-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.unit-modal-field label {\n  font-weight: 600;\n  color: var(--ui-text);\n}\n\n.unit-modal-field input:not([type=\"checkbox\"]),\n.unit-modal-field select,\n.unit-modal-field textarea {\n  width: 100%;\n  background: #fff;\n  border: 1px solid var(--ui-border);\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.unit-modal-field input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  align-self: flex-start;\n}\n\n.unit-modal-field textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.unit-modal-field.span-2 {\n  grid-column: span 2;\n}\n\n.unit-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 720px) {\n  .unit-modal-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .unit-modal-field.span-2 {\n    grid-column: span 1;\n  }\n}\n\n/* Css do box */\n.box {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n}\n\n.box .existing-services,\n.box .added-services {\n  width: 50%;\n  padding: 10px;\n  border-radius: 8px;\n  position: relative;\n  border: 1px solid #ccc;\n  margin-top: 10px;\n}\n\n.box .existing-services h2,\n.box .added-services h2 {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.box li {\n  cursor: pointer;\n  margin-bottom: 5px;\n}\n\n.box li:hover {\n  background-color: var(--fundo)\n}\n\n\n.existing-services::before {\n  content: '>';\n  display: block;\n  position: absolute;\n  bottom: 5px;\n  right: 2px;\n  padding: 0px 1px 2px 4px;\n  border: 1px solid var(--texto);\n  border-radius: 50%;\n}\n\n.added-services::after {\n  content: '<';\n  display: block;\n  position: absolute;\n  bottom: 5px;\n  left: 2px;\n  padding: 0px 1px 2px 4px;\n  border: 1px solid var(--texto);\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
